/* eslint-disable class-methods-use-this */
export default class MetricNameRule {
  isSupport(filters, node) {
    if (filters.metric_name === 'is_data_leaving_eea' && node.data.attributes.is_data_leaving_eea) {
      return true;
    }
    if (filters.metric_name === 'is_fingerprinting' && node.data.attributes.is_fingerprinting) {
      return true;
    }
    if (filters.metric_name === 'is_local_storage' && node.data.attributes.is_local_storage) {
      return true;
    }
    return false;
  }
  getStrokeColor() {
    return '#CC483B';
  }
  getBorderColor() {
    return '#CC483B';
  }
}
